import { useMutation } from 'react-query';
import { useLocale } from '../../../../../../../i18n';
import { IdResponse } from '../../../../../../../types/API';
import { wgApi } from '../../../../../../app/src/features/api/wgApi';

interface Params {
  conversationId: string;
  userLang: string;
  userCountry: string;
  version?: string;
}

const createRecommendationsByConversationId = async ({
  conversationId,
  userLang,
  userCountry,
  version,
}: Params) => {
  const { data, isError } = await wgApi.post<IdResponse>(
    `/v1/api/insurance-recommendations?lang=${userLang}&country=${userCountry}`,
    {
      conversation_id: conversationId,
      products_version: version,
    },
  );
  if (isError) throw new Error();
  return data;
};

export const useCreateRecommendation = () => {
  const { userLang, userCountry } = useLocale();

  return useMutation((conversationId: string) =>
    createRecommendationsByConversationId({
      conversationId,
      userLang,
      userCountry,
      version: 'V2',
    }),
  );
};
